import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../components/ToastMsg";
import "react-loading-skeleton/dist/skeleton.css";
import styles from './index.module.css';
import SearchBar from "../../../components/SearchBar";
import TableSkeleton from "../../../components/Skeleton";
import { editVehicle, getAllVehicles } from "../../../redux/features/vehicle/vehicleService";
import Pagination from "../../../components/Pagination";
import NoResultsFound from "../../../components/NoResultsFound";
import Modal from "../../../components/Modal";
import { faCircleCheck, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const Vehicles = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isVehiclesLoading, pageCount, vehicles } = useSelector((state) => state.vehicle.allVehicles);

    const [searchQuery, setSearchQuery] = useState('');
    const [skip, setSkip] = useState(0);
    const limit = 10;

    const [selectedCountryId, setSelectedCountryId] = useState(null);
    const [isActivateModalOpen, setActivateModalOpen] = useState(false);
    const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);

    const fetchAllVehicles = useCallback(() => {
        dispatch(getAllVehicles({
            skip: searchQuery !== ''? 0 : skip,
            limit,
            search: searchQuery
        }));
    }, [dispatch, skip, searchQuery]);

    useEffect(() => {
        fetchAllVehicles();
    }, [fetchAllVehicles]);

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber - 1);
    };
    
    const closeModal = () => setActivateModalOpen(false);
    const closDeactivationModal = () => setDeactivationModalOpen(false);

    const handleYes = async () => {
        setActivateModalOpen(false);
        try {
            const response = await dispatch(editVehicle({ id: selectedCountryId, status: true })).unwrap();
            setSelectedCountryId(null);
            showToast('success', response.message);
            fetchAllVehicles();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }
    const handleRejectYes = async () => {
        setDeactivationModalOpen(false);
        try {
            const response = await dispatch(editVehicle({ id: selectedCountryId, status: false })).unwrap();
            setSelectedCountryId(null);
            showToast('success', response.message);
            fetchAllVehicles();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }

    const openVehicleEdit = (id) => {
        navigate(`/manager/vehicles/${id}`)
    }

    return (
        <div className={`search-card`}>
            <div className={`search-card-header`}>
                <h1 className={`form-title`}>Vehicles</h1>
                <SearchBar onSearch={(query) => setSearchQuery(query)} />
            </div>
            <div className={`search-card-body`}>
                {isVehiclesLoading ?
                    <TableSkeleton columns={["Thumbnail Image", "Chassis No", "Vehicle", "Stock No", "Actions"]} rowCount={10} height={20} />
                    : vehicles.length > 0 ?
                        <div className={`table-container`}>
                            <table className={`table`}>
                                <thead className={`thead`}>
                                    <tr>
                                        <th className={`theadColumnOne`}>Thumbnail Image</th>
                                        <th>Vehicle</th>
                                        <th>Chassis No</th>
                                        <th>Stock No</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className={`tbody`}>
                                    {vehicles?.map((vehicle) => (
                                        <tr key={vehicle.id}>
                                            <td className={`tdataColumnOne`}>
                                              <img
                                                    src={vehicle.image_url}
                                                    width={80}
                                                    alt="Vehicle"
                                                />
                                            </td>
                                            <td>
                                                 {vehicle.name} 
                                            </td>
                                            <td>{vehicle.chassis_no}</td>
                                            <td>{vehicle.stock_no}</td>
                                            <td className={`actionsBtn ${styles.actionCol}`}>                                          
                                                <button className={`btn-edit-label`} onClick={() => {
                                                    openVehicleEdit(vehicle.id)
                                                }}>Edit</button>
                                                <button
                                                    className={vehicle.status ? `btn-inactive` : `btn-active`}
                                                    onClick={() => {
                                                        setSelectedCountryId(vehicle.id);
                                                        vehicle.status ? setDeactivationModalOpen(true) : setActivateModalOpen(true);
                                                    }
                                                    }>{vehicle.status ? 'Deactivate' : 'Acitvate'}</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        :
                        <NoResultsFound />
                }
            </div>
            <div className={`search-card-footer`}>
                {pageCount > 0 && (
                    <div className={styles.paginationContainer}>
                        <Pagination
                            currentPage={skip + 1}
                            totalPages={pageCount}
                            onPageChange={handlePageChange}
                        />
                    </div>
                )}
            </div>
            {isActivateModalOpen && (
                <Modal
                    title='Vehicle Activation'
                    onClose={closeModal}
                    onYes={handleYes}
                    isInput={false}
                    iconName={faCircleCheck}
                    bodyText={`Are you sure you want to activate the Vehicle?`}
                    colorType={`var(--green)`}
                />
            )}
            {isDeactivationModalOpen && (
                <Modal
                    title='Vehicle Deactivation'
                    onClose={closDeactivationModal}
                    onYes={handleRejectYes}
                    isInput={false}
                    iconName={faCircleXmark}
                    bodyText={`Are you sure you want to deactivate the Vehicle?`}
                    colorType={`var(--danger)`}
                />
            )}
        </div>
    );
};

export default Vehicles;
